import { render, staticRenderFns } from "./GuideConfigModal.vue?vue&type=template&id=67ad661f&scoped=true"
import script from "./GuideConfigModal.vue?vue&type=script&lang=js"
export * from "./GuideConfigModal.vue?vue&type=script&lang=js"
import style0 from "./GuideConfigModal.vue?vue&type=style&index=0&id=67ad661f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad661f",
  null
  
)

export default component.exports